import React from 'react'

function aspectRatio(story) {
  const imgMeta = story["hero-image-metadata"];
  const imgHeight = imgMeta?.height || 2160;
  const imgWidth = imgMeta?.width || 3840;
  function calculateAspectRatio(height, width) {
    const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
    const commonDivisor = gcd(height, width);
    const aspRatio = [height / commonDivisor, width / commonDivisor];
    return aspRatio;
}
  const aspRto = calculateAspectRatio(imgHeight,imgWidth);
  return aspRto
}

export default aspectRatio
